import React, { useEffect, useState, useCallback, Suspense, lazy } from 'react'
import { clearSessionToken, getSessionToken } from './session'
import { Router, Route, Switch, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'

import history from 'globalHistory'
import { checkLoginStatus } from './Utils'
import { setAccounts, setLoadingAccounts } from 'redux/accounts'
import {
  setResources,
  setLoadingResources,
  invalidateResources,
} from 'redux/resources'
import {
  setWMLResources,
  setLoadingWMLResources,
  invalidateWMLResources,
} from 'redux/wmlResources'
import { setProfile } from 'redux/profile'

import ReactGA from 'react-ga4'

import { Main } from './Lander/Main'
import { About } from './Lander/About'
import { AppPage } from './Lander/App'
import { Studies } from './Lander/Studies'
import { FAQ } from './Lander/FAQ'

const AppSandbox = lazy(() => import('./App/AppSandbox'))
const App = lazy(() => import('./App/App'))
const Home = lazy(() => import('./Home/Home'))
const Privacy = lazy(() => import('./Home/Privacy'))
const DeleteData = lazy(() => import('./Home/DeleteData'))
const Projects = lazy(() => import('./Projects/Projects'))
const Training = lazy(() => import('./Training/Base'))
const Login = lazy(() => import('./Login/Login'))
const Reset = lazy(() => import('./Login/Reset'))
const SuccessBlank = lazy(() => import('./Data/SuccessBlank'))
const ResetToken = lazy(() => import('./Login/ResetToken'))
const Data = lazy(() => import('./Data/Data'))
const DataNew = lazy(() => import('./Data/DataNew'))
const DataAccess = lazy(() => import('./Data/DataAccess'))
const Devices = lazy(() => import('./Devices/Devices'))
const Success = lazy(() => import('./Data/Success'))
const Kiosk = lazy(() => import('./Kiosk/Kiosk'))
const Mobile = lazy(() => import('./Kiosk/Mobile'))

/**
 * Confirms the stored session with the server on load. The token is sent by
 * the fetch wrapper (session.js); a 401 means the session was revoked or
 * expired and the browser goes back to the login form. A transport failure is
 * retried, bounded, rather than treated as a sign-out.
 */
const RECHECK_LIMIT = 20

const checkAuth = () => {
  const loadAccount = (tries) => {
    fetch(`/auth/session`)
      .then((response) => {
        if (response.status === 401) return { message: 'sign in required' }
        if (!response.ok) throw new Error('server ' + response.status)
        return response.json()
      })
      .then((data) => {
        if (data.message == 'success') {
          window.user = data.user
          // authenticated successfully
          if (history.location.pathname == '/login') {
            if (data.user.admin == true) {
              history.replace('/projects')
            } else {
              history.replace(`/view/me`)
            }
          } else {
            if (data.user.admin == true) {
              // pass
            } else {
              history.replace(`/view/me`)
            }
          }
        } else {
          clearSessionToken()
          localStorage.setItem('authenticatedUser', undefined)
          history.push('/')
        }
      })
      .catch((error) => {
        if (tries < RECHECK_LIMIT) {
          setTimeout(() => {
            loadAccount(tries + 1)
          }, 1000)
        }
      })
  }
  loadAccount(0)
}

const authenticatedUser = () => {
  // a session token is the sign of a logged-in browser; 'authenticatedUser'
  // (now just the email) is kept for the pages that read it
  if (!getSessionToken()) {
    localStorage.setItem('authenticatedUser', undefined)
  }

  if (
    localStorage.getItem('authenticatedUser') == 'undefined' ||
    localStorage.getItem('authenticatedUser') == null
  ) {
    // setAttemptedPage(history.location.pathname + history.location.search)
    if (
      history.location.pathname != '/' &&
      history.location.pathname != '/login' &&
      history.location.pathname.indexOf('/reset') == -1 &&
      history.location.pathname.indexOf('/privacy') == -1 &&
      history.location.pathname.indexOf('/deletedata') == -1 &&
      history.location.pathname.indexOf('/success') == -1 &&
      history.location.pathname.indexOf('/about') == -1 &&
      history.location.pathname.indexOf('/app') == -1 &&
      history.location.pathname.indexOf('/faq') == -1 &&
      history.location.pathname.indexOf('/studies') == -1 &&
      history.location.pathname.indexOf('sharedata') == -1 &&
      history.location.pathname.indexOf('view') == -1
    ) {
      history.replace('/')
    }
  } else {
    checkAuth()
  }
}

const useAccount = (dispatch) => {
  /*
    const loadAccounts = useCallback(
      (tries = 0) => {
        fetch('/api/accounts')
          .then(res => res.json())
          .then(accounts => {
            dispatch(setAccounts(accounts))
            dispatch(setLoadingAccounts(false))
            if (accounts.length === 0 && tries < 300) {
              setTimeout(() => {
                loadAccounts(tries + 1)
              }, 10000)
            }
          })
          .catch(error => {
            console.error(error)
          })
      }, [dispatch]
    )
  */

  useEffect(() => {
    dispatch(setLoadingAccounts(false))
    //loadAccounts()
  }, [dispatch])
}

const useUpgradeToken = (account) => {
  /*
  const [tokenUpgraded, setTokenUpgraded] = useState(false)
  useEffect(() => {
    setTokenUpgraded(false)
    if (account) {
      fetch(`/api/upgrade-token?account=${account}`)
        .then(() => {
          setTokenUpgraded(account)
        })
        .catch(error => {
          console.error(error)
        })
    }
  }, [account])

  return tokenUpgraded
  */
}

const recursivelyFetchResources = async (url, oldResources) => {
  if (url) {
    const trimmed = url.replace(/^\/v2\/resource_instances/, '')
    const json = await fetch(`/api/cos-instances${trimmed}`).then((r) =>
      r.json()
    )
    const { next_url, resources } = json
    return recursivelyFetchResources(next_url, [...oldResources, ...resources])
  }
  return oldResources
}

const recursivelyFetchWMLResources = async (url, oldResources) => {
  if (url) {
    const trimmed = url.replace(/^\/v2\/resource_instances/, '')
    const json = await fetch(`/api/wml-instances${trimmed}`).then((r) =>
      r.json()
    )
    const { next_url, resources } = json
    return recursivelyFetchWMLResources(next_url, [
      ...oldResources,
      ...resources,
    ])
  }
  return oldResources
}

const useWMLResourceList = (dispatch, tokenUpgraded) => {
  const loadWMLResources = useCallback(
    (tries = 0) => {
      fetch('/api/wml-instances')
        .then((res) => res.json())
        .then((allResources) => {
          //   //recursivelyFetchWMLResources(json.next_url, json.resources)
          // )
          // .then(allResources => {

          // Alphabetize the list by name.
          allResources.sort((a, b) =>
            a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
          )

          dispatch(setWMLResources(allResources))
          dispatch(setLoadingWMLResources(false))
          if (allResources.length === 0 && tries < 300) {
            setTimeout(() => {
              loadWMLResources(tries + 1)
            }, 10000)
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },
    [dispatch]
  )

  useEffect(() => {
    if (tokenUpgraded) {
      dispatch(invalidateWMLResources(true))
      loadWMLResources()
    }
  }, [dispatch, loadWMLResources, tokenUpgraded])
}

const useProfile = (dispatch, account) => {
  useEffect(() => {
    if (account) {
      /*
      fetch('/auth/userinfo')
        .then(res => res.text())
        .then(userId => fetch(`/api/accounts/${account}/users/${userId}`))
        .then(res => res.json())
        .then(user => {
          console.log(user);
          dispatch(setProfile(user))
        })
        .catch(error => {
          console.error(error)
        })
        */
    }
  }, [account, dispatch])
}

const Routing = ({ dispatch, activeAccount }) => {
  const attemptedPage = authenticatedUser()

  useAccount(dispatch)

  useEffect(() => {
    if (activeAccount) {
      dispatch(invalidateResources())
    }

    fetch('/api/version')
      .then((d) => {
        return d.json()
      })
      .then((d) => {
        // console.log(d)
        if (Object.keys(d).indexOf('ga') > -1) {
          console.log('initializing GA:', d['ga'])
          ReactGA.initialize(d['ga'])
        }
      })
  }, [activeAccount, dispatch])

  const tokenUpgraded = useUpgradeToken(activeAccount)

  // useResourceList(dispatch)
  //useWMLResourceList(dispatch, tokenUpgraded)
  //useProfile(dispatch, activeAccount)

  return (
    <Router history={history}>
      <Suspense fallback={<div></div>}>
        <Switch>
          {/* <Route
            exact
            path="/"
            render={(props) => (
              <Home {...props} attemptedPage={attemptedPage} />
            )}
          /> */}
          <Route exact path="/" component={Main} />
          <Route exact path="/about" component={About} />
          <Route exact path="/app" component={AppPage} />
          <Route exact path="/studies" component={Studies} />
          <Route exact path="/faq" component={FAQ} />

          <Route exact path="/projects" component={Projects} />
          <Route exact path="/data" component={Projects} />
          <Route exact path="/sandbox" component={AppSandbox} />
          <Route exact path="/training" component={Training} />
          <Route
            exact
            path="/login"
            render={(props) => (
              <Login {...props} attemptedPage={attemptedPage} />
            )}
          />
          <Route exact path="/reset/:token" component={ResetToken} />
          <Route exact path="/reset" render={(props) => <Reset {...props} />} />

          <Route exact path="/success" component={SuccessBlank} />

          <Route exact path="/projects/:project" component={App} />

          <Route exact path="/view/:id" component={Kiosk} />
          <Route exact path="/view/:id/mobile" component={Mobile} />

          <Route exact path="/sharedata/:id" component={DataNew} />
          {/* <Route exact path="/sharedata-new/:id" component={DataNew} /> */}

          <Route exact path="/sharedata/:id/access" component={DataAccess} />
          <Route exact path="/sharedata_success" component={Success} />

          <Route exact path="/devices" component={Devices} />

          <Route exact path="/privacy" component={Privacy} />
          <Route exact path="/deletedata" component={DeleteData} />

          <Route
            path="/:project"
            component={({
              match: {
                params: { project },
              },
              location: { search },
            }) => <Redirect to={`/projects/${project}${search}`} />}
          ></Route>
        </Switch>
      </Suspense>
    </Router>
  )
}

const mapStateToProps = (state) => ({
  activeAccount: state.accounts.activeAccount,
})
export default connect(mapStateToProps)(Routing)
